export default {"src":"/_next/static/media/priority_urgent.295ff610.svg","height":140,"width":140,"blurWidth":0,"blurHeight":0};